import { render, staticRenderFns } from "./modalRejectCarrier.vue?vue&type=template&id=260306f4&scoped=true"
import script from "./modalRejectCarrier.vue?vue&type=script&lang=js"
export * from "./modalRejectCarrier.vue?vue&type=script&lang=js"
import style0 from "./modalRejectCarrier.vue?vue&type=style&index=0&id=260306f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260306f4",
  null
  
)

export default component.exports